<template>
	<v-form
		class="note-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<div class="d-flex justify-space-between flex-wrap align-start mb-3">
			<div style="width: 100%">
				<div class="post-text__text-container">
          <h2 class="post-text__text-container__title">Note</h2>
					<v-textarea
						class="post-text__fields-input note-form pt-0 rounded custom-textarea"
						v-model="fields.text"
						:rules="[...rules.required, ...rules.maxLength]"
						:error-messages="field_errors.required"
						auto-grow
						rows="1"
						row-height="22"
						dense
						placeholder="Your note here..."
						required
					>
					</v-textarea>
				</div>

				<p
					class="red--text text-center"
					v-for="error in errors"
					:key="error"
					style="width: 100%"
				>
					{{ error }}
				</p>
			</div>
		</div>
		<span class="post-text__field-message">*Note will be visible only to you</span>

		<div class="button-wrapper mt-4">
			<v-btn class="button buttonCancel elevation-0" outlined @click="closeModal">
				Cancel
			</v-btn>

			<v-btn
				class="button buttonSave elevation-0"
				:loading="isLoading"
				:disabled="isLoading"
				@click="validateAndSubmit"
			>
				Save
			</v-btn>
		</div>
	</v-form>
</template>

<script>
import { ruleRequired } from '@/utils/rules'
import Form from '@/mixins/Form'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'NoteTextForm',
	mixins: [Form],

	props: {
		activeTab: {
			type: Number,
			default: 0,
		},
		resourceItem: {
			type: Object,
			default: null,
		},
		id: {
			type: Number,
			default: 0,
		},
		note: {
			type: String,
			default: '',
		},
		edit: {
			type: Boolean,
			default: false,
		},
		userPage: {
			type: Boolean,
			default: false,
		},
	},

	data: () => ({
		fields: {
			text: '',
		},

		menuProps: {
			maxWidth: '250px',
			offsetY: true,
		},
	}),
	computed: {
		...mapGetters('profile', ['isLoading', 'editableNote']),

		rules() {
			return {
				required: [(v) => ruleRequired(v) || this.userPage || 'Field is required.'],
				maxLength: [
					(v) => {
						if (!v) return true
						return v.length <= 4048 || 'Maximum length is 4048 characters.'
					},
				],
			}
		},
	},
	watch: {
		isLoading(newValue, oldValue) {
			!newValue && oldValue && this.edit && this.closeModal()
		},
		editableNote(newValue, oldValue) {
			if (this.$route.name === 'user-by-id') {
        this.getAttendee(this.$route.params.id)
				this.$emit('closeModal')
			} else {
				newValue &&
					!oldValue &&
					!this.edit &&
					this.$router.push({
						name: 'profile-note-by-id',
						params: { id: this.id },
					})
			}
		},
	},
	methods: {
		...mapActions('profile', ['updateNote', 'updateEditableNote', 'addNote', 'deleteNote']),
		...mapActions('app', ['showAlert']),
		...mapActions('event', ['getAttendee']),

		async submitForm() {
			if (this.edit) {
				let isUpdated = false
				if (this.fields.text) {
					isUpdated = await this.updateNote({
						id: this.id,
						text: this.fields.text,
					})
				} else {
					isUpdated = await this.deleteNote(this.id)
				}
				this.$route.name === 'user-by-id' &&
					isUpdated && this.getAttendee(this.$route.params.id)
			} else {
				await this.addNote({
					follow_id: this.id,
					follow_note: this.fields.text,
				})
			}
		},

		closeModal() {
			this.$emit('closeModal')
			this.$refs.form.reset()
		},
	},

	created() {
		this.fields.text = this.note
	},
}
</script>

<style lang="scss">
.post-text {
	&__field-title {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
	}
	&__text-container {
		border: 1px solid #e2e2e2;
		padding: 12px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		gap: 8px;
		max-height: 500px;
		overflow-y: auto;
    &__title {
      font-family: Inter, sans-serif;
      font-weight: 500;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0;
      color: #4a4a4a;
    }
	}
	&__field-message {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: #9b9b9b;
	}
	&__note-title {
		font-family: 'Inter', sans-serif;
		font-weight: 500;
		font-size: 18px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
	}

	&__field-loader {
		width: 100%;
		height: 40px;
	}

	&__fields-input {
		.v-input__control {
			max-height: none !important;
		}
		textarea {
			overflow-y: hidden !important;
			resize: none !important;
		}
		min-height: 22px !important;
		.menu__content {
			width: 200px !important;
		}

		.v-input__slot {
			min-height: 22px !important;
			box-shadow: none !important;
			border: unset !important;
			padding: 0 !important;
			margin-bottom: 0 !important;
		}
		i {
			color: #bbbbbb !important;
		}
		.v-select__selections {
			flex-wrap: nowrap;
			overflow: scroll;
			&::-webkit-scrollbar {
				display: none;
			}
		}
		.v-chip {
			min-width: fit-content;
		}
	}

	&__field-select {
		padding: 0;
		margin: 0;
		.v-select__slot {
			height: 40px;
			border: 1px solid rgb(223, 223, 223);
			border-radius: 6px;
		}

		i {
			margin-top: 10px;
			margin-right: 10px;
			color: #bbbbbb !important;
		}
		button {
			margin-top: 10px;
		}
	}
	&__confirm-delete {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: 'Inter', sans-serif;
		font-weight: 500;
		&-text {
			color: var(--accent-color);
			font-size: 18px;
			font-family: 'Inter', sans-serif;
			font-weight: bold;
			text-decoration: underline;
			letter-spacing: -0.34px;
		}
	}
	&__file-wrapper {
		display: flex;
		flex-wrap: wrap;
		column-gap: 40px;
	}
	&__file-container {
		background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23A0A0A0FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
		width: 250px;
		height: 130px;
		cursor: pointer;

		img {
			width: 250px;
			height: 130px;
			object-fit: contain;
			cursor: auto;
		}

		input {
			width: 250px;
			height: 130px;
			position: absolute;
			opacity: 0;
			cursor: pointer;
		}
		&-file-uploader {
			width: 250px;
			height: 130px;
			position: absolute;
			opacity: 0;
			cursor: pointer;
		}
		&-title {
			display: flex;
			color: rgb(74, 74, 74);
			font-size: 14px;
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			letter-spacing: -0.34px;
		}
		&-description {
			color: rgb(112, 128, 144);
			font-size: 12px;
			font-family: 'Inter', sans-serif;
			font-weight: normal;
			text-align: center;
			letter-spacing: -0.29px;
		}
		&-link {
			color: rgb(66, 160, 216);
			font-family: 'Inter', sans-serif;
			font-weight: bold;
			text-decoration: underline;
		}
		&-loader {
			height: 135px;
		}
	}
}

.v-input--reverse .v-input__slot {
	border: none !important;
	flex-direction: row-reverse;

	.v-application--is-ltr & {
		.v-input--selection-controls__input {
			margin-right: 0;
			margin-left: 8px;
		}
	}
	.v-application--is-rtl & {
		.v-input--selection-controls__input {
			margin-left: 0;
			margin-right: 8px;
		}
	}
}

.v-input__slot:before {
	display: none;
}

.v-menu__content {
	width: 250px;
}
.note-form {
  textarea {
    min-height: 22px !important;
    padding: 0 !important;
    resize: none !important;
    overflow: hidden !important;
    font-family: 'Inter', sans-serif !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    line-height: 100% !important;
    letter-spacing: 0 !important;
    color: #4a4a4a;
  }
  .v-textarea {
    .v-input__slot:before {
      border-color: var(--vote_bar_tint) !important;
    }

    .v-input__slot:after {
      border-color: var(--vote_bar_tint) !important;
    }
    &.v-input--is-focused {
      .v-input__slot:before {
        border-color: var(--vote_bar_tint) !important;
      }
    }
  }
}

div .button-wrapper {
	display: flex;
	justify-content: center;
	gap: 16px;

	@media (max-width: 400px) {
		justify-content: space-between;
	}
}

div .button {
	font-family: 'Inter', sans-serif !important;
	border-width: 2px;
	border-radius: 8px;
	font-size: 18px !important;
	line-height: 100% !important;
	font-weight: 700;
	letter-spacing: 0;
	text-transform: capitalize;
	padding: 12px 44px !important;
	height: 44px !important;

	@media (max-width: 400px) {
		padding: 10px 0 !important;
		flex-grow: 1;
	}

	&Cancel {
		color: var(--accent-color) !important;
		background: #ffffff !important;
	}

	&Save {
		background: var(--accent-color) !important;
		color: #fff !important;
	}
}
</style>
